import {
  ListingConnection,
  ListingInput,
  Paginate,
} from '../../graphql/Listing';

// zero-based index
export const INITIAL_PAGE = 0;

// @see https://github.com/referenceable/referenceable_api/blob/develop/app/graphql/private/queries/private_query.rb
export const MAX_LIMIT = 1000;

export const getAllPages = async <ObjectType>(
  getter: (input: Paginate) => Promise<ListingConnection<ObjectType>>,
  limit = MAX_LIMIT
) => {
  const listing: ListingConnection<ObjectType> = { nodes: [], totalCount: 0 };
  let completed = false;
  let page = INITIAL_PAGE;
  do {
    try {
      const input: ListingInput = { limit };
      // `offset` must be null on first page to retrieve the total count value
      if (page !== INITIAL_PAGE) {
        input.offset = page * limit;
      }
      const { nodes, totalCount } = await getter(input);
      listing.nodes.push(...nodes);
      // Only the first page includes the total count
      if (typeof totalCount === 'number') {
        listing.totalCount = totalCount;
      }
      // Stop condition: less results than the page size
      if (nodes.length < limit) {
        completed = true;
      } else {
        // Continue loading the next page
        page += 1;
      }
    } catch (e) {
      // @todo implement retries
      completed = true;
    }
  } while (!completed);
  return listing;
};

export const getAllPagesNextPage = async <ObjectType>(
  getter: (input: Paginate) => Promise<ListingConnection<ObjectType>>,
  limit = MAX_LIMIT
) => {
  const listing: ListingConnection<ObjectType> = { nodes: [], totalCount: 0 };
  let completed = false;
  let nextPageParam;
  do {
    try {
      const input: ListingInput = { limit };

      if (nextPageParam) {
        input.after = nextPageParam;
      }

      const { nodes, nextPage } = await getter(input);

      listing.nodes.push(...nodes);

      nextPageParam = nextPage;
      // Stop condition: less results than the page size
      if (nodes.length < limit || !nextPageParam) {
        completed = true;
      }
    } catch (e) {
      // @todo implement retries
      completed = true;
      throw e;
    }
  } while (!completed);
  return listing;
};
